fragment AIChatMessageFragment on AIChatMessage {
  id
  role
  content
  status
  citations
  respondsTo
  startedAt
  endedAt
  modelId
  createdAt
  updatedAt
  error
  errorDetails
  feedbackRating
  feedbackComment
  tools {
    id
    result
    args
    thought
    status
    error
    errorDetails
    externalId
    callingAgentId
    modelId
    toolCalledAt
    toolResultAt
    createdAt
    updatedAt
  }
}



query getExistingAIResponse($sourceId: String!, $subjectId: String!) {
  result: getExistingAIResponse(sourceId: $sourceId, subjectId: $subjectId) {
    content
    success
    complete
    message
    streaming
  }
}

query getPublicAIChatTranscript($sourceId: String!, $params: String) {
  result: getPublicAIChatTranscript(sourceId: $sourceId, params: $params) {
    success
    message
    complete
    hasError
    streaming
    messages {
      role
      content
      complete
    }
  }
}

mutation createNewAITranscriptVersion($sourceId: String!, $params: String) {
  response: createNewAITranscriptVersion(sourceId: $sourceId, params: $params) {
    success
    message
    startPolling
  }
}

mutation generateNewAISummary($sourceId: String!, $subjectId: String!) {
  response: generateNewAISummary(sourceId: $sourceId, subjectId: $subjectId) {
    success
    message
    startPolling
  }
}

query getTranscriptList($min: String, $max: String) {
  result: getTranscriptList(min: $min, max: $max) {
    content
    success
  }
}

query getAIChats {
  chats: getAIChats {
    id
    title
    createdAt
    updatedAt
  }
}

query getAIChatById($id: String!) {
  chat: getAIChatById(id: $id) {
    id
    title
    createdAt
    updatedAt
    messages {
      ...AIChatMessageFragment
    }
  }
}

query findAIChatById($id: String!) {
  chat: findAIChatById(id: $id) {
    id
    participantId
    title
    createdAt
    updatedAt
    messages {
      ...AIChatMessageFragment
    }
  }
}

query getAIDashboards {
  dashboards: getAIDashboards {
    id
    title
    aiChatId
    createdAt
    updatedAt
  }
}

query getAIDashboardById($id: String!, $version: String) {
  dashboard: getAIDashboardById(id: $id, version: $version) {
    id
    title
    aiChatId
    createdAt
    updatedAt
    content
    versionNumber
    latestVersionNumber
    lastPublishedVersionNumber
    lastPublishedAt
    css
    template
    queries
    variables
  }
}

query getAISummaries($searchTerm: String, $limit: Int, $offset: Int) {
  getAISummaries(searchTerm: $searchTerm, limit: $limit, offset: $offset) {
    summaries {
      id
      entityType
      entityId
      status
      error
      createdAt
      updatedAt
      lastRefreshedAt
    }
    total
  }
}

query searchAIChats($searchTerm: String, $limit: Int, $offset: Int) {
  searchAIChats(searchTerm: $searchTerm, limit: $limit, offset: $offset) {
    chats {
      id
      participantId
      title
      createdAt
      updatedAt
    }
    total
  }
}

query getAISummaryById($id: String!) {
  getAISummaryById(id: $id) {
    id
    entityType
    entityId
    systemPrompt
    userPrompt
    content
    citations
    lastRefreshedAt
    status
    error
    createdAt
    updatedAt
  }
}
